import "./buttonFile.scss";

export interface ButtonFileProps {
  onChange: (e: any) => void;
  onClick?: () => void;
  className?: string;
  testId?: string;
  disabled?: boolean;
  hidden?: boolean;
  text: string;
}

export const ButtonFile = (props: ButtonFileProps) => {
  return (
        <button
            className={`button-file ${props?.className ?? ""}`}
            data-testid={props?.testId ?? "button-test"}
            onClick={props?.onClick}
        >
            {props.text}
            <input
                type="file"
                accept="image/png, image/jpeg"
                onChange={props.onChange}
            />
        </button>
    );
};
